module.exports = __webpack_public_path__ + "static/media/soundBalanceNew.9270f6f1.mp3";